// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"25ed93d6d3fe4f7a2a28","293":"0064c2b02d4632fe3d09","518":"ff15b82e3b9f0038c8fd","779":"6dd9ac2d7af62bf4ae6b"}[chunkId] + ".js";
};